export const baseUrl = 'https://backend-vlabs.deviare.co.za/';
export const baseAuth = 'https://t2nnwx48lk.execute-api.us-west-2.amazonaws.com/production/v1/';